import { Component, Input } from "@angular/core";
import {
  TaskDto,
  ResourceDto,
  EnumNamesValuesDto,
  TaskStatusMetaDto,
} from "src/app/web-api/web-api";

@Component({
    selector: "app-planung-task-card-tooltip",
    templateUrl: "./task-card-tooltip.component.html",
    styleUrls: ["./task-card-tooltip.component.css"],
    standalone: false
})
export class PlanungAPITaskCardTooltipComponent {
  @Input() task: TaskDto = null;
  @Input() resources: ResourceDto[] = null;
  @Input() taskStates: EnumNamesValuesDto = null;
  @Input() stateMeta: TaskStatusMetaDto = null;

  public GetAssignedToName(task: TaskDto): string {
    if (!this.resources || !task) {
      return null;
    }

    if (!task.assignedToResourceID) {
      return null;
    }
    const assigned = this.resources.find(
      r => r.id === task.assignedToResourceID,
    );
    if (!assigned) {
      return null;
    }
    return assigned.name;
  }
  public GetClaimedByName(task: TaskDto): string {
    if (!this.resources || !task) {
      return null;
    }

    if (!task.claimResourceID) {
      return null;
    }
    const claimed = this.resources.find(r => r.id === task.claimResourceID);
    if (!claimed) {
      return null;
    }
    return claimed.name;
  }

  public GetTaskState(task: TaskDto): string {
    if (!task || !this.taskStates) {
      return null;
    }
    const state = this.taskStates.namesValues.find(e => e.value === task.state);
    if (!state) {
      return null;
    }
    return state.name;
  }

  public GetAnlageNr(task: TaskDto): string {
    return task.anlageNrIntern;
  }

  public GetShouldDisplayTaskLocation(task: TaskDto): boolean {
    if (!task || !task.workLocation) {
      return false;
    }
    const loc = task.workLocation;
    return (!(!loc.street && !loc.streetNo && !loc.city && !loc.postalCode));
  }
  public GetTaskLocationString(task: TaskDto): string {
    const loc = task.workLocation;
    const name = (loc.name|| "").trim();
    const cityPostal = (loc.postalCode + " " + loc.city).trim();
    const streetAndNo = (loc.street + " " + loc.streetNo).trim();
    return (name.length > 0 ? `${name} - ` : "") + cityPostal + (cityPostal.length > 0 ? " - " : "") + streetAndNo;
  }
}
